module.exports = __webpack_public_path__ + "static/media/fax.9856e85b.svg";